import { FC } from "react";
import {
  ParticipantType,
  WithdrawalReason,
} from "../../model/registrationEnums";
import {
  SelectFormField,
  TextFormField,
} from "@blanket/components/formFields/FormFields";

type LeavingPartyFieldsProps = {
  namePrefix: string;
  idPrefix: string;
  participantType: string;
  withdrawalReason: string;
};

export const LeavingPartyFields: FC<LeavingPartyFieldsProps> = ({
  namePrefix,
  idPrefix,
  participantType,
  withdrawalReason,
}) => (
  <div className="d-flex flex-column gap-4">
    <SelectFormField
      name={`${namePrefix}.participantType`}
      label="Type"
      id={`${idPrefix}-participant-type`}
      isRequired
      options={[
        { value: ParticipantType.Person, label: "Fysisk person" },
        { value: ParticipantType.Company, label: "Advokatselskab" },
      ]}
    />
    {participantType === ParticipantType.Person && (
      <>
        <SelectFormField
          name={`${namePrefix}.withdrawalReason`}
          label="Årsag til udtræden"
          id={`${idPrefix}-withdrawal-reason`}
          isRequired
          options={[
            {
              value: WithdrawalReason.ContinuesAsLawyer,
              label: "Fortsætter som advokat i en anden virksomhed",
            },
            {
              value: WithdrawalReason.Deposits,
              label: "Deponerer",
            },
          ]}
        />
        {withdrawalReason === WithdrawalReason.ContinuesAsLawyer && (
          <div className="blanket-two-col">
            <TextFormField
              name={`${namePrefix}.continuedCompanyName`}
              label="Hvilken virksomhed?"
              id={`${idPrefix}-continued-company-name`}
              isRequired
            />
            <TextFormField
              name={`${namePrefix}.continuedCompanyCvr`}
              label="CVR-nummer"
              id={`${idPrefix}-continued-company-cvr`}
              isRequired
              type="number"
            />
          </div>
        )}
      </>
    )}
  </div>
);
